module.exports = __webpack_public_path__ + "static/img/zebra.33e6242.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zebra.svg
// module id = ouwd
// module chunks = 1